import { render, staticRenderFns } from "./ServiceAccountsEdit.vue?vue&type=template&id=152cb1ca"
import script from "./ServiceAccountsEdit.vue?vue&type=script&lang=js"
export * from "./ServiceAccountsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports